import React from 'react';
import { Card } from 'reactstrap';
import Collapse from '../../../shared/components/Collapse';
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalendarBlankIcon, FilterIcon, CheckIcon } from "mdi-react";
import * as websites from "../../../shared/service/websites";
import * as users from "../../../shared/service/users";

import store from '../redux/store/index';

class UsersFilter extends React.Component {
  state = {
    statuses: [],
    productTypes: [],
    accountTypes: [],
    sources: [],
    domains: [],
    verificationStatus: [],
    onboardingStatus: [],
    min_bandwidth: '',
    max_bandwidth: '',
    min_proxies: '',
    max_proxies: ''
  };

  page = ''

  componentDidMount() {
    this.page = this.props.page;

    let state = store.getState().usersFilters;
    this.setState(state, () => {
      this.getWebsites();
      this.getOnBoardingStatuses();
      this.filterUsers();
    });
  }

  getOnBoardingStatuses = () => {
    users.getOnBoardingStatuses().then((onboardingStatus) => {
      onboardingStatus.map(obj => obj.checked = false );
      this.setState({ onboardingStatus });
    });
  };

  getWebsites = () => {
    websites.get().then((response) => {
      this.setState({ domains: response.data });
    });
  };

  filterUsers = () => {
    this.props.onFilterClicked(this.state);
  }

  updateStatusState = (status) => {
    let statuses = this.state.statuses;
  
    statuses.forEach(obj => {
      if (obj.key === status.key) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({statuses}, () => {
      this.filterUsers();
    });
  };

  updateProductTypeState = (productType) => {
    let productTypes = this.state.productTypes;
  
    productTypes.forEach(obj => {
      if (obj.key === productType.key) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({productTypes}, () => {
      this.filterUsers();
    });
  }

  updateAccountTypeState  = (accountType) => {
    let accountTypes = this.state.accountTypes;
  
    accountTypes.forEach(obj => {
      if (obj.key === accountType.key) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({accountTypes}, () => {
      this.filterUsers();
    });
  }

  updateSourcesState = (source) => {
    let sources = this.state.sources;
  
    sources.forEach(obj => {
      if (obj.key === source.key) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({sources}, () => {
      this.filterUsers();
    });
  }

  updateDomainState = (domain) => {
    let domains = this.state.domains;
  
    domains.forEach(obj => {
      if (obj.url === domain.url) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({domains}, () => {
      this.filterUsers();
    });
  }

  updateVerificationStatusState = (status) => {
    let verificationStatus = this.state.verificationStatus;
  
    verificationStatus.forEach(obj => {
      if (obj.key === status.key) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({verificationStatus}, () => {
      this.filterUsers();
    });
  }

  updateOnboardingStatusState  = (status) => {
    let onboardingStatus = this.state.onboardingStatus;
  
    onboardingStatus.forEach(obj => {
      if (obj.value === status.value) {
        obj.checked = !obj.checked;
      } 
    });
    
    this.setState({onboardingStatus}, () => {
      this.filterUsers();
    });
  }

  formChangeHandler = (event) => {   
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({[nam]: val}, () => {
      this.filterUsers();
    });
  }

  handleChange = ({ startDate, endDate }) => {
    const changedStartDate = startDate || this.state.startDate;
    let changedEndDate = endDate || this.state.endDate;

    if (moment(changedStartDate).isAfter(moment(changedEndDate))) {
      changedEndDate = changedStartDate;
    }

    this.setState({ startDate: changedStartDate, endDate: changedEndDate }, () => {
      this.filterUsers();
    });
  };

  handleChangeStart = startDate => this.handleChange({ startDate });

  handleChangeEnd = endDate => this.handleChange({ endDate });

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.props.page !== 'Dashboard' ? 
      
        <Card className="filter-section">
          <div className="card__title">
            <h5 className="bold-text">
              Filters
            </h5>
            <FilterIcon color="#999" size={14} />
          </div>
          <div className="form wild-card-search">
            <div className="form__form-group search-bar">
              <span className="form__form-group-label">Search</span>
              <div className="form__form-group-field">
                <input type="search" placeholder="Search by Name, Email, Authroized IP" name="key" onKeyUp={this.formChangeHandler} />
              </div>
              <small><i>Search by Name, Email, Authroized IP</i></small>
            </div>
          </div>
          <Collapse title="bandwidth usage">
            <div className="form__form-group">
            <div className="form__form-group-field">
              <input className="react-datepicker__input-container" type="number" min="0" max="1000" placeholder="Min" name="min_bandwidth" onChange={this.formChangeHandler} />
              <span className="inputSeperator">to</span>
              <input className="react-datepicker__input-container" type="number" min="0" max="1000" placeholder="Max" name="max_bandwidth" onChange={this.formChangeHandler} />
            </div>
            </div>
          </Collapse>
          <Collapse title="Credits">
            <div className="form__form-group">
            <div className="form__form-group-field">
              <input className="react-datepicker__input-container" type="number" min="0" max="10000" placeholder="Min" name="min_credits" onChange={this.formChangeHandler} />
              <span className="inputSeperator">to</span>
              <input className="react-datepicker__input-container" type="number" min="0" max="10000" placeholder="Max" name="max_credits" onChange={this.formChangeHandler} />
            </div>
            </div>
          </Collapse>
          <Collapse title="Time Range">
            <div className="form range-pickers">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <div className="date-picker">
                    <DatePicker 
                      selected={moment(this.state.startDate)}
                      selectsStart
                      onChange={this.handleChangeStart}
                    />
                  </div>
                  <div className="form__form-group-icon">
                    <CalendarBlankIcon />
                  </div>
                </div>
              </div>
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <div className="date-picker">
                    <DatePicker
                      selected={moment(this.state.endDate)}
                      selectsEnd 
                      onChange={this.handleChangeEnd}
                    />
                  </div>
                  <div className="form__form-group-icon">
                    <CalendarBlankIcon />
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
          {/* <Collapse title="Account Type">
            <div className="form status-filters">
            {this.state.accountTypes.map(accountType => (
                <div key={accountType.key} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={accountType.key}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      checked={accountType.checked}
                      id={accountType.key} 
                      onChange={() => this.updateAccountTypeState(accountType)}
                    />
                    <span className="checkbox-btn__checkbox-custom" style={accountType.color ? { background: accountType.color, borderColor: accountType.color } : {}}><CheckIcon /></span>
                    <span className="checkbox-btn__label">{accountType.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse> */}
          {this.props.type === 'all' || this.props.type === 'Recent_Signups'? <Collapse title="Account Status">
            <div className="form status-filters">
            {this.state.statuses.map(status => (
                <div key={status.key} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={status.key}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      checked={status.checked}
                      id={status.key} 
                      onChange={() => this.updateStatusState(status)}
                    />
                    <span className="checkbox-btn__checkbox-custom" style={status.color ? { background: status.color, borderColor: status.color } : {}}><CheckIcon /></span>
                    <span className="checkbox-btn__label">{status.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>: ''}
          <Collapse title="Product type">
            <div className="form status-filters">
            {this.state.productTypes.map(productType => (
                <div key={productType.key} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={productType.key}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      checked={productType.checked}
                      id={productType.key} 
                      onChange={() => this.updateProductTypeState(productType)}
                    />
                    <span className="checkbox-btn__checkbox-custom" style={productType.color ? { background: productType.color, borderColor: productType.color } : {}}><CheckIcon /></span>
                    <span className="checkbox-btn__label">{productType.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>
          <Collapse title="Proxies">
            <div className="form__form-group">
            <div className="form__form-group-field">
              <input className="react-datepicker__input-container" type="number" min="0" max="1000" placeholder="Min" name="min_proxies" onChange={this.formChangeHandler} />
              <span className="inputSeperator">to</span>
              <input className="react-datepicker__input-container" type="number" min="0" max="1000" placeholder="Max" name="max_proxies" onChange={this.formChangeHandler} />
            </div>
            </div>
          </Collapse>
          {/* <Collapse title="Tags">
            <div className="form__form-group">
              <div className="form__form-group-field">
                <input type="search" placeholder="Search by product tags" name="tags" onKeyUp={this.formChangeHandler} />
              </div>
            </div>
          </Collapse> */}
          <Collapse title="Source">
            <div className="form status-filters">
            {this.state.sources.map(source => (
                <div key={source.key} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={source.key}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      checked={source.checked}
                      id={source.key} 
                      onChange={() => this.updateSourcesState(source)}
                    />
                    <span className="checkbox-btn__checkbox-custom" style={source.color ? { background: source.color, borderColor: source.color } : {}}><CheckIcon /></span>
                    <span className="checkbox-btn__label">{source.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>
          <Collapse title="Domains">
            <div className="form status-filters">
            {this.state.domains.map(domain => (
                <div key={'domain_key_'+domain.id} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={'domain_htmlFor_'+domain.id}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      checked={domain.checked}
                      id={'domain_htmlFor_'+domain.id} 
                      onChange={() => this.updateDomainState(domain)}
                    />
                    <span className="checkbox-btn__checkbox-custom" style={domain.color ? { background: domain.color, borderColor: domain.color } : {}}><CheckIcon /></span>
                    <span className="checkbox-btn__label">{domain.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>
          {this.props.verificationStatus === undefined ? 
            <Collapse title="Verification Status">
            <div className="form status-filters">
            {this.state.verificationStatus.map(verificationStatus => (
                <div key={verificationStatus.key} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={verificationStatus.key}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      checked={verificationStatus.checked}
                      id={verificationStatus.key} 
                      onChange={() => this.updateVerificationStatusState(verificationStatus)}
                    />
                    <span className="checkbox-btn__checkbox-custom" style={verificationStatus.color ? { background: verificationStatus.color, borderColor: verificationStatus.color } : {}}><CheckIcon /></span>
                    <span className="checkbox-btn__label">{verificationStatus.name}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>
          :''}
          <Collapse title="Onboarding Status">
            <div className="form status-filters">
            {this.state.onboardingStatus.map(obj => (
                <div key={obj.value} className="form__form-group-field checkbox-filter-field">
                  <label className="checkbox-btn checkbox-btn--colored" htmlFor={obj.value}>
                    <input
                      className="checkbox-btn__checkbox"
                      type="checkbox" 
                      id={obj.value} 
                      onChange={() => this.updateOnboardingStatusState(obj)}
                    />
                    <span className="checkbox-btn__checkbox-custom" ><CheckIcon /></span>
                    <span className="checkbox-btn__label">{obj.label}</span>
                  </label>
                </div>
              ))}
            </div>
          </Collapse>
        </Card>
      : ''  }
      </React.Fragment>
    );
  }
}

export default UsersFilter;
